import pharmacy from 'services/pharmacy';

export default () => {
  return async (postcode) => {
    try {
      const response = await pharmacy.get(`/pharmacies/direct-delivery-range-of/${postcode}`, {
        headers: { 'api-version': 'v2' },
      });
      return response.data;
    } catch (e) {
      return ({ pharmacies: [] });
    }
  };
};
